import type { ShareableImageType } from '@src/types.ts/story';

type CardMetadata = ShareableImageType['metadata'] | null;

/**
 * The quote card's Speaker dropdown reads `speakerLabel` by the card
 * composition's element id, which a template switch replaces. Carry the label
 * to the new id, unless that id already has one (a design restored from the
 * switch cache keeps the speaker it shows).
 */
export function carryCardSpeakerLabel(
  metadata: CardMetadata,
  fromId: string,
  toId: string,
): CardMetadata {
  const speakerLabel = metadata?.[fromId]?.speakerLabel;
  if (speakerLabel === undefined) return metadata;
  if (metadata?.[toId]?.speakerLabel !== undefined) return metadata;
  return { ...metadata, [toId]: { ...metadata?.[toId], speakerLabel } };
}
